/**
 * Ohio county catalogue.
 *
 * Source: U.S. Census Bureau, 2020 national county file
 * https://www2.census.gov/geo/docs/reference/codes2020/national_county2020.txt
 * filtered to STATE = OH. Retrieved 2026-08-04.
 *
 * Ohio has 88 counties; every FIPS code begins with 39.
 *
 * Data only. See `shared/counties/index.ts` for the unified catalogue.
 */

import type { CatalogueCounty } from './types.js';

export const OHIO_COUNTY_DATA: readonly CatalogueCounty[] = [
  { name: 'Adams', state: 'OH', fips: '39001' },
  { name: 'Allen', state: 'OH', fips: '39003' },
  { name: 'Ashland', state: 'OH', fips: '39005' },
  { name: 'Ashtabula', state: 'OH', fips: '39007' },
  { name: 'Athens', state: 'OH', fips: '39009' },
  { name: 'Auglaize', state: 'OH', fips: '39011' },
  { name: 'Belmont', state: 'OH', fips: '39013' },
  { name: 'Brown', state: 'OH', fips: '39015' },
  { name: 'Butler', state: 'OH', fips: '39017' },
  { name: 'Carroll', state: 'OH', fips: '39019' },
  { name: 'Champaign', state: 'OH', fips: '39021' },
  { name: 'Clark', state: 'OH', fips: '39023' },
  { name: 'Clermont', state: 'OH', fips: '39025' },
  { name: 'Clinton', state: 'OH', fips: '39027' },
  { name: 'Columbiana', state: 'OH', fips: '39029' },
  { name: 'Coshocton', state: 'OH', fips: '39031' },
  { name: 'Crawford', state: 'OH', fips: '39033' },
  { name: 'Cuyahoga', state: 'OH', fips: '39035' },
  { name: 'Darke', state: 'OH', fips: '39037' },
  { name: 'Defiance', state: 'OH', fips: '39039' },
  { name: 'Delaware', state: 'OH', fips: '39041' },
  { name: 'Erie', state: 'OH', fips: '39043' },
  { name: 'Fairfield', state: 'OH', fips: '39045' },
  { name: 'Fayette', state: 'OH', fips: '39047' },
  { name: 'Franklin', state: 'OH', fips: '39049' },
  { name: 'Fulton', state: 'OH', fips: '39051' },
  { name: 'Gallia', state: 'OH', fips: '39053' },
  { name: 'Geauga', state: 'OH', fips: '39055' },
  { name: 'Greene', state: 'OH', fips: '39057' },
  { name: 'Guernsey', state: 'OH', fips: '39059' },
  { name: 'Hamilton', state: 'OH', fips: '39061' },
  { name: 'Hancock', state: 'OH', fips: '39063' },
  { name: 'Hardin', state: 'OH', fips: '39065' },
  { name: 'Harrison', state: 'OH', fips: '39067' },
  { name: 'Henry', state: 'OH', fips: '39069' },
  { name: 'Highland', state: 'OH', fips: '39071' },
  { name: 'Hocking', state: 'OH', fips: '39073' },
  { name: 'Holmes', state: 'OH', fips: '39075' },
  { name: 'Huron', state: 'OH', fips: '39077' },
  { name: 'Jackson', state: 'OH', fips: '39079' },
  { name: 'Jefferson', state: 'OH', fips: '39081' },
  { name: 'Knox', state: 'OH', fips: '39083' },
  { name: 'Lake', state: 'OH', fips: '39085' },
  { name: 'Lawrence', state: 'OH', fips: '39087' },
  { name: 'Licking', state: 'OH', fips: '39089' },
  { name: 'Logan', state: 'OH', fips: '39091' },
  { name: 'Lorain', state: 'OH', fips: '39093' },
  { name: 'Lucas', state: 'OH', fips: '39095' },
  { name: 'Madison', state: 'OH', fips: '39097' },
  { name: 'Mahoning', state: 'OH', fips: '39099' },
  { name: 'Marion', state: 'OH', fips: '39101' },
  { name: 'Medina', state: 'OH', fips: '39103' },
  { name: 'Meigs', state: 'OH', fips: '39105' },
  { name: 'Mercer', state: 'OH', fips: '39107' },
  { name: 'Miami', state: 'OH', fips: '39109' },
  { name: 'Monroe', state: 'OH', fips: '39111' },
  { name: 'Montgomery', state: 'OH', fips: '39113' },
  { name: 'Morgan', state: 'OH', fips: '39115' },
  { name: 'Morrow', state: 'OH', fips: '39117' },
  { name: 'Muskingum', state: 'OH', fips: '39119' },
  { name: 'Noble', state: 'OH', fips: '39121' },
  { name: 'Ottawa', state: 'OH', fips: '39123' },
  { name: 'Paulding', state: 'OH', fips: '39125' },
  { name: 'Perry', state: 'OH', fips: '39127' },
  { name: 'Pickaway', state: 'OH', fips: '39129' },
  { name: 'Pike', state: 'OH', fips: '39131' },
  { name: 'Portage', state: 'OH', fips: '39133' },
  { name: 'Preble', state: 'OH', fips: '39135' },
  { name: 'Putnam', state: 'OH', fips: '39137' },
  { name: 'Richland', state: 'OH', fips: '39139' },
  { name: 'Ross', state: 'OH', fips: '39141' },
  { name: 'Sandusky', state: 'OH', fips: '39143' },
  { name: 'Scioto', state: 'OH', fips: '39145' },
  { name: 'Seneca', state: 'OH', fips: '39147' },
  { name: 'Shelby', state: 'OH', fips: '39149' },
  { name: 'Stark', state: 'OH', fips: '39151' },
  { name: 'Summit', state: 'OH', fips: '39153' },
  { name: 'Trumbull', state: 'OH', fips: '39155' },
  { name: 'Tuscarawas', state: 'OH', fips: '39157' },
  { name: 'Union', state: 'OH', fips: '39159' },
  { name: 'Van Wert', state: 'OH', fips: '39161' },
  { name: 'Vinton', state: 'OH', fips: '39163' },
  { name: 'Warren', state: 'OH', fips: '39165' },
  { name: 'Washington', state: 'OH', fips: '39167' },
  { name: 'Wayne', state: 'OH', fips: '39169' },
  { name: 'Williams', state: 'OH', fips: '39171' },
  { name: 'Wood', state: 'OH', fips: '39173' },
  { name: 'Wyandot', state: 'OH', fips: '39175' },
];
